import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Strings } from "../../shared/tools/Strings";
import { ValuesResult } from "../model/ValuesResult";

@Injectable({
  providedIn: "root"
})
export class ValuesService {
  public data: ValuesResult | null;
  public loading: boolean;
  public error: string | null;

  constructor(
    public readonly httpClient: HttpClient,
  ) {
    this.data = null;
    this.loading = false;
    this.error = null;
  }

  public async loadValues(): Promise<void> {
    try {
      this.loading = true;
      this.error = null;
      const result = await this.httpClient.get<ValuesResult>(
        "/api/values",
        {
          params: {
            flat: "false",
          }
        }
      ).toPromise();
      this.data = result;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      if (e instanceof HttpErrorResponse) {
        this.error = `Error: ${e.error?.message ?? Strings.unknownError}`;
      } else if (e instanceof Error) {
        this.error = e.message;
      } else {
        this.error = Strings.unknownError;
      }
    }
  }
}
